'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessiblePopOver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _basePopupManager = require('@bibliocommons/base-popup-manager');

var _basePopupManager2 = _interopRequireDefault(_basePopupManager);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/AccessiblePopOver.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var handleTriggerClick = function handleTriggerClick(e, popupActions) {
  e.preventDefault();
  popupActions.toggleContent();
};

var AccessiblePopOver = exports.AccessiblePopOver = function (_BcReactComponent) {
  _inherits(AccessiblePopOver, _BcReactComponent);

  function AccessiblePopOver(props) {
    _classCallCheck(this, AccessiblePopOver);

    var _this = _possibleConstructorReturn(this, (AccessiblePopOver.__proto__ || Object.getPrototypeOf(AccessiblePopOver)).call(this, props));

    _this.bindAll('getTriggerWidth', 'getArrowOffset', 'renderTrigger', 'renderPopUp', 'setTriggerRef');
    return _this;
  }

  _createClass(AccessiblePopOver, [{
    key: 'getTriggerWidth',
    value: function getTriggerWidth() {
      return this._trigger ? this._trigger.getBoundingClientRect().width : 0;
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      var offset = Math.floor(this.getTriggerWidth() / 2);
      return offset + 'px';
    }
  }, {
    key: 'renderTrigger',
    value: function renderTrigger(popupActions) {
      return _react2.default.createElement(
        'a',
        {
          className: 'trigger-link',
          ref: this.setTriggerRef,
          href: this.props.href,
          onClick: function onClick(e) {
            return handleTriggerClick(e, popupActions);
          } },
        this.props.triggerContent
      );
    }
  }, {
    key: 'setTriggerRef',
    value: function setTriggerRef(el) {
      this._trigger = el;
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton(popupActions) {
      // eslint-disable-line class-methods-use-this
      var handleClose = function handleClose(e) {
        e.preventDefault();
        popupActions.closeAndFocusContent();
      };

      return _react2.default.createElement(
        _baseButtons.TextButton,
        {
          className: 'close-button',
          handleClick: handleClose },
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
        ),
        _react2.default.createElement(_baseIcons.Cross, null)
      );
    }
  }, {
    key: 'renderPopUp',
    value: function renderPopUp(popupActions) {
      return _react2.default.createElement(
        'div',
        { className: 'absolute-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'pop-up' },
          _react2.default.createElement('div', {
            className: 'pop-up-arrow',
            style: { left: this.getArrowOffset() } }),
          this.props.children,
          this.renderCloseButton(popupActions)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _basePopupManager2.default,
        { className: 'cp-accessible-pop-over', renderContent: this.renderPopUp },
        this.renderTrigger
      );
    }
  }]);

  return AccessiblePopOver;
}(_baseBcReactComponent2.default);

AccessiblePopOver.propTypes = {
  href: _react.PropTypes.string,
  triggerContent: _react.PropTypes.node,
  children: _react.PropTypes.node
};

exports.default = AccessiblePopOver;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-pop-over/lib/components/AccessiblePopOver.component.js
// module id = 1011
// module chunks = 1